import { Button, Card, CardBody, Col, Form, Input } from 'reactstrap';
import { Bio, BioText, LastName, MyProfiles, Save } from '../../../../../constants';
import CommonUserFormGroup from '../common/CommonUserFormGroup';
import { UserFormHead } from './UserFormHead';
import CommonCardHeader from '../../../../../coreComponents/CommonCardHeader';
import { UserRole } from '../../../../../types/Forms';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface ProfileData {
  dob: Date | null;
  city: string | null;
  email: string;
  firstName: string;
  lastName: string;
  telegram: string | null;
  photo: string | null;
  role: UserRole;
  updater: (data: { firstName: string; lastName: string } | { photo: File }) => void;
}
const MyProfile = ({
  dob,
  city,
  email,
  firstName = '',
  lastName = '',
  photo,
  role,
  telegram,
  updater,
}: ProfileData) => {
  // const [userFName, setUserFName] = useState(firstName);
  // const [userLName, setUserLName] = useState(lastName);
  const [updatePayload, setUpdatePayload] = useState<{
    firstName: string;
    lastName: string;
    dob: string | null;
    city: string | null;
  }>({
    firstName: firstName,
    lastName: lastName,
    dob: dob ? new Date(dob).toISOString().split('T')[0] : null,
    city: city,
  });
  const { t } = useTranslation();

  const fullName = updatePayload.firstName ?? ''.concat(updatePayload.lastName ?? '');
  return (
    <Col xl="4">
      <Card>
        <CommonCardHeader title={t('profilePage.myData')} headClass="pb-0" />
        <CardBody>
          <Form
            onSubmit={(event) => {
              event.preventDefault();
              const payload = {
                firstName: updatePayload.firstName ?? '',
                lastName: updatePayload.lastName ?? '',
                dob: updatePayload.dob,
                city: updatePayload.city,
              };
              updater(payload);
            }}
          >
            <UserFormHead
              name={fullName === '' ? 'Name not added' : fullName}
              photo={photo}
              role={role}
              onAvatarSelected={(photoFile) => updater({ photo: photoFile })}
            />
            {/* <div className="mb-3">
              <h6 className="form-label">{Bio}</h6>
              <Input type="textarea" rows={4} defaultValue={BioText} />
            </div> */}

            {/* <CommonUserFormGroup type="password" title="Password" defaultValue="Password" /> */}
            <CommonUserFormGroup
              type="text"
              title={t('profilePage.firstName')}
              placeholder="John"
              // defaultValue={userFName ?? ''}
              onChange={(e) => setUpdatePayload({ ...updatePayload, firstName: e.target.value })}
              value={updatePayload.firstName}
              required={true}
            />
            <CommonUserFormGroup
              type="text"
              title={t('profilePage.lastName')}
              placeholder="Smith"
              // defaultValue={userLName ?? ''}
              onChange={(e) => setUpdatePayload({ ...updatePayload, lastName: e.target.value })}
              value={updatePayload.lastName}
              required={true}
            />
            <CommonUserFormGroup
              type="email"
              title="Email"
              placeholder="your-email@domain.com"
              // defaultValue={email}
              value={email}
              isDisabled
            />
            <CommonUserFormGroup
              type="text"
              title="Telegram"
              placeholder="@myAccount"
              // defaultValue={telegram ?? ''}
              value={telegram ?? ''}
              isDisabled
            />

            <CommonUserFormGroup
              type="text"
              title={t('profilePage.city')}
              placeholder={t('profilePage.city')}
              value={updatePayload.city ?? ''}
              onChange={(e) => setUpdatePayload({ ...updatePayload, city: e.target.value })}
              required={true}
            />
            <CommonUserFormGroup
              type="date"
              title={t('profilePage.dob')}
              // defaultValue={dob ? new Date(dob).toISOString().split('T')[0] : ''}
              value={
                updatePayload.dob
                  ? new Date(updatePayload.dob).toISOString().split('T')[0]
                  : new Date().toISOString().split('T')[0]
              }
              onChange={(e) =>
                setUpdatePayload({
                  ...updatePayload,
                  dob: e.target.value ? new Date(e.target.value).toISOString().split('T')[0] : null,
                })
              }
              required={true}
            />
            <div>
              <Button color="primary" className="d-block">
                {t('global.save')}
              </Button>
            </div>
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default MyProfile;
